module.exports = __webpack_public_path__ + "img/gioco.be449db6.png";